import React from "react";

const attachmentRows = [
  {
    type: "Certificat SON MANCAP",
    reference: "TVO243861",
    emitter: "Yikodeen",
    date: "02.04.2024",
    expiration: "02.04.2027",
    status: "Valide",
    statusType: "green",
  },
  {
    type: "Fiche technique produit",
    reference: "O878059862",
    emitter: "Yikodeen",
    date: "18.18.2023",
    expiration: "06.04.2025",
    status: "Expiré",
    statusType: "orange",
  },
  {
    type: "Rapport de test produit",
    reference: "—",
    emitter: "Sunagro Exports",
    date: "18.12.2025",
    expiration: "22.04.2027",
    status: "Valide",
    statusType: "green",
  },
  {
    type: "Certificat QMS",
    reference: "O878059862",
    emitter: "Facture proforma",
    date: "18.09.2029",
    expiration: "22.04.2027",
    status: "Valide",
    statusType: "green",
  },
];

function AttachmentStatus({ type, children }) {
  return (
    <>
      <span className={`pat-status ${type}`}>{children}</span>
      <style>{`
        .pat-status {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 92px;
          height: 32px;
          padding: 0 14px;
          border-radius: 999px;
          font-size: 13px;
          font-weight: 700;
          white-space: nowrap;
        }

        .pat-status.green {
          background: linear-gradient(180deg, #4f8b67, #41735a);
          color: #f2fff7;
        }

        .pat-status.orange {
          background: linear-gradient(180deg, #d79b39, #bb7f1d);
          color: #fff8e8;
        }
      `}</style>
    </>
  );
}

export default function ProductAttachmentsTable() {
  return (
    <>
      <div className="pat-card">
        <div className="pat-top">
          <h3>Pièces jointes / base de conformité</h3>
          <div className="pat-top-actions">
            <button>＋</button>
            <button>＋ Quelier pièces...▾</button>
          </div>
        </div>

        <div className="pat-table-wrap">
          <table className="pat-table">
            <thead>
              <tr>
                <th>Type de document ▾</th>
                <th>Référence</th>
                <th>Emetteur</th>
                <th>Date ▾</th>
                <th>Expiration ▾</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {attachmentRows.map((row, index) => (
                <tr key={index}>
                  <td>🟢 {row.type}</td>
                  <td>{row.reference}</td>
                  <td>{row.emitter}</td>
                  <td>{row.date}</td>
                  <td>{row.expiration}</td>
                  <td><AttachmentStatus type={row.statusType}>{row.status}</AttachmentStatus></td>
                  <td><button className="pat-row-btn">Qunit pièce ▾</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="pat-bottom">
          <span>↑ </span>
          <button className="pat-delete-btn">Retire dossier</button>
        </div>
      </div>

      <style>{`
        .pat-card {
          margin-top: 16px;
          border-radius: 16px;
          overflow: hidden;
          background: linear-gradient(180deg, rgba(28,38,73,0.96), rgba(20,28,55,0.96));
          border: 1px solid rgba(255,255,255,0.07);
          box-shadow: 0 14px 32px rgba(0,0,0,0.24);
        }

        .pat-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
          padding: 16px 18px;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }

        .pat-top h3 {
          margin: 0;
          color: #f2f6ff;
          font-size: 20px;
          font-weight: 700;
        }

        .pat-top-actions {
          display: flex;
          gap: 8px;
        }

        .pat-top-actions button,
        .pat-row-btn,
        .pat-delete-btn {
          height: 36px;
          padding: 0 12px;
          border-radius: 8px;
          border: 1px solid rgba(255,255,255,0.08);
          background: rgba(255,255,255,0.04);
          color: #edf3ff;
          font-size: 14px;
          cursor: pointer;
        }

        .pat-table-wrap {
          overflow-x: auto;
        }

        .pat-table {
          width: 100%;
          border-collapse: collapse;
        }

        .pat-table thead th {
          text-align: left;
          padding: 14px 14px;
          background: linear-gradient(180deg, rgba(42,52,96,0.95), rgba(34,44,84,0.95));
          color: #eef3ff;
          font-size: 14px;
          font-weight: 700;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }

        .pat-table tbody td {
          padding: 16px 14px;
          color: #d7e1ff;
          font-size: 15px;
          border-bottom: 1px solid rgba(255,255,255,0.06);
          vertical-align: middle;
        }

        .pat-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
          padding: 14px 18px;
          color: #aebad9;
          font-size: 13px;
        }

        .pat-delete-btn {
          background: linear-gradient(180deg, #8b4343, #6d3232);
          color: #fff1f1;
        }

        @media (max-width: 760px) {
          .pat-top,
          .pat-bottom {
            flex-direction: column;
            align-items: flex-start;
          }
        }
      `}</style>
    </>
  );
}